<script>
  import { createEventDispatcher } from 'svelte'
  import { faXmark } from '@fortawesome/pro-regular-svg-icons'

  import Icon from '../Icon'
  import filterClasses, { cssPrefix } from '../helper-classes.js'

  // why not replace with button icon=Close ?
  export let id = null
  export let style = null
  export let helperClass = null
  export let size = 1
  let importedClasses = ''
  export { importedClasses as class }
  export let classPermissiveMode = false
  if (helperClass) {
    console.debug("[DS:deprecation] please replace 'helperClass' prop by 'class'")
    if (!importedClasses) {
      importedClasses = helperClass
    }
  }
  const classes = [`${cssPrefix}close`]
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))

  const dispatch = createEventDispatcher()

  const close = () => {
    dispatch('close')
  }

  const slots = $$slots
</script>

<button
  class={classes.join(' ')}
  {style}
  on:click={e => {
    e.preventDefault()
    close()
  }}
  {id}
>
  {#if slots && Object.prototype.hasOwnProperty.call(slots, 'default')}
    <slot />
  {:else}
    <Icon icon={faXmark} scale={size} />
  {/if}
</button>
